import { lazy } from 'react';

const YearlyContactInfoModal = lazy(() =>
  import('./YearlyContactInfoModal/YearlyContactInfoModal.js'),
);

export default {
  YEARLY_CONTACT_INFO_MODAL: YearlyContactInfoModal,
};
